// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3DAfi","rootSmall":"AddTileButton_rootSmall__EteIT"};